import './index.css';
import Hero from '../../components/Hero';
import Button from '../../components/Button';
import ButtonShareWsp from '../../components/ButtonShareWsp';
import Footer from '../../components/Footer';

const sectionDesc = 'Quiero compartir este artículo contigo: ¿En qué cree el Cristiano Presbiteriano?';

export default function EnQueCreemos() {
    return (
        <main className="g-main en-que-creemos">
            <Hero title="¿En qué creemos?" description="¿En qué cree el Cristiano Presbiteriano?" size='s' />
            <section className="content-main">
                <div className="g-share-wsp">
                    <ButtonShareWsp
                        url={window.location.href}
                        text={`${sectionDesc}\n\n`}
                    >
                        <Button label="Compartir" />
                    </ButtonShareWsp>
                </div>
                <ol>
                    <li>
                        La inspiración divina, plenaria y verbal, de las Sagradas Escrituras en sus originales; su consecuente inerrabilidad e infalibilidad y, como Palabra de Dios su autoridad única y final para la fe y la conducta.
                    </li>
                    <li>
                        El Dios Trino: Padre, Hijo y Espíritu Santo.
                    </li>
                    <li>
                        La deidad eterna, esencial y absoluta, así como la real, propia e inmaculada humanidad de nuestro Señor Jesucristo.
                    </li>
                </ol>
                <ol>
                    <li>
                        Su nacimiento de Maria virgen.
                    </li>
                    <li>
                        Su muerte expiatoria y substitucional, puesto que “dio su vida en rescate por muchos”.
                    </li>
                    <li>
                        Su resurrección de entre los muertos con el mismo cuerpo con que fue crucificado y su segunda venida, con poder y gran gloria.
                    </li>
                    <li>
                        La depravación total del hombre, debido a la caída.
                    </li>
                    <li>
                        La salvación como resultado de la regeneración por el Espíritu Santo y la Palabra de Dios; no por obras, sino por gracia, por medio de la fe; y
                    </li>
                    <li>
                        La eterna felicidad de los salvos y el sufrimiento eterno de los perdidos.
                    </li>
                    <li>
                        La unidad espiritual verdadera en Cristo de todos los redimidos por su preciosa sangre, a causa del Espíritu Santo que vive en ellos.
                    </li>
                    <li>
                        La necesidad de mantener, conforme a la palabra de Dios, la pureza de la Iglesia en doctrina y conducta.
                    </li>
                    <li>
                        Creemos también que el Credo de los apóstoles es, principalmente una afirmación de la verdad bíblica.
                    </li>
                </ol>
                <p>
                    Como fundamentalistas bíblicos rechazamos toda acción violenta y terrorista y creemos que es tarea esencial de la Iglesia:
                </p>
                <ol>
                    <li>
                        Evangelizar.
                    </li>
                    <li>
                        Edificar la fe de los creyentes; y
                    </li>
                    <li>
                        Defender la fe activa y militantemente y mantenerse separada de los que profesan ser cristianos, pero no son fieles a la Palabra de Dios, y de toda forma de apostasía.
                    </li>
                </ol>
                <p>Además como presbiterianos, creemos en:</p>
                <ol>
                    <li>
                        La soberana elección de gracia desde la eternidad de los redimidos y en su predestinación para la salvación;
                    </li>
                    <li>
                        La recepción voluntaria del evangelio por parte de los elegidos, debido a que Dios inclina su voluntad, sin forzarla, para que lo haga;
                    </li>
                    <li>
                        Que solo Dios es Señor de la conciencia, por lo cual la ha hecho libre de toda doctrina o mandamiento de hombre, pero completamente sometida a la Palabra de Dios.
                    </li>
                </ol>
                <p>
                    Que una parte mayor de la Iglesia debe gobernar a una parte menor y resolver toda controversia de doctrina o conducta que se produzca en la parte menor.
                </p>
            </section>
            <Footer />
        </main>
    );
}